import {intersperse, omit} from 'ramda';
import React from 'react';
import {bool, string, node, oneOf, func} from 'prop-types';
import classNames from 'classnames';
import styles from './FilterList.css';
import Checkbox from '../../forms/Checkbox';

export const FilterCheckbox = props => (
  <Checkbox
    onChange={props.onChange}
    className={classNames(styles.checkbox, styles.FilterItem)}
    theme="alternate"
    checked={props.isOn}
    label={props.children}
  />
);
FilterCheckbox.propTypes = {
  onChange: func.isRequired,
  isOn: bool,
  children: node.isRequired,
};

export const FilterItem = props => (
  <a
    {...omit(['isOn', 'children', 'className'], props)}
    className={classNames(
      {[styles.isOn]: props.isOn},
      styles.FilterItem,
      props.className
    )}
  >
    {props.children}
  </a>
);
FilterItem.propTypes = {
  isOn: bool,
  className: string,
  children: node.isRequired,
  type: oneOf(['checkbox', 'radio']),
  onClick: func,
};

export const Separator = () => <span className={styles.Separator}>|</span>;

let separatorKey = 0;

// addSeparators :: [React.node] -> [React.node]
export const addSeparators = intersperse(
  <Separator key={'separator' + separatorKey++} /> //eslint-disable-line no-plusplus
);

const FilterList = ({label, children}) => {
  return (
    <nav className={styles.FilterList}>
      <header className={styles.FilterLabel}>{label}</header>
      <div className={styles.FilterItems}>{children}</div>
    </nav>
  );
};
FilterList.propTypes = {
  label: node,
  children: node,
};
export default FilterList;
